import { SocialSecurityLoading } from './Loading';
import { SocialSecuritySignedPage } from './SignedPage';
import { SocialSecurityOTP } from './OTP';
import { SocialSecurityPersonalDocument } from './PersonalDocument';
import { SocialSecurityFaceRecognition } from './FaceRecognition';
import { SocialSecurityResumeOperation } from './ResumeOperation';
import { SocialSecurityPortabilityAndRefinancingSummary } from './PortabilityAndRefinancingSummary';
import { SocialSecurityRefinancingSummary } from './RefinancingSummary';
import { SocialSecurityDeviceScan } from './DeviceScan';
import { SocialSecurityConfiaPage } from './ConfiaPage';

export const SocialSecurityTheme = {
    Loading: SocialSecurityLoading,
    ConfiaPage: SocialSecurityConfiaPage,
    SignedPage: SocialSecuritySignedPage,
    OTP: SocialSecurityOTP,
    PersonalDocument: SocialSecurityPersonalDocument,
    FaceRecognition: SocialSecurityFaceRecognition,
    ResumeOperation: SocialSecurityResumeOperation,
    PortabilityAndRefinancingSummary: SocialSecurityPortabilityAndRefinancingSummary,
    RefinancingSummary: SocialSecurityRefinancingSummary,
    DeviceScan: SocialSecurityDeviceScan,
} as const;
